import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import T from 'prop-types';
import { keys } from 'lodash-es';

import InsightsCardBox from '../../../../../pages/app-insights/_shared/components/InsightsCardBox';
import YearCohortsChart from '../../../../../pages/app-insights/_shared/components/YearCohortsChart';
import { AdvancedKeyMetricTooltip } from '../../../../../pages/app-insights/_shared/components/AdvancedMetricDropdown';
import { sortSegmentsData } from '../../../../../pages/app-insights/_shared/config/finance/cohorts';

import { fetchAppQuickviewByAsset } from '../../../actions';
import { ADVANCED_METRICS_APP } from '../../../../../utils/advanced-metrics';

const getInitialMetrics = (keyMetric) => {
  const restMetrics = keys(ADVANCED_METRICS_APP).filter((m) => m !== keyMetric);

  return [keyMetric].concat(restMetrics).slice(0, 3);
};

const AdvancedDataPerformance = ({ widgets, data, settings }) => {
  const dispatch = useDispatch();

  const { advanced_metrics_insights } = widgets;
  const keyMetric = advanced_metrics_insights.key_metric;

  const { advanced_time_series: { cohorts = {}, year_sub_dates, filters = {} } = {} } = data;

  const { groupedSegments } = sortSegmentsData(advanced_metrics_insights.all);
  const advancedData = groupedSegments.all?.[0] || {};

  const activeMetrics = getInitialMetrics(keyMetric);

  useEffect(() => {
    if (!cohorts[advancedData.cohort]) {
      dispatch(
        fetchAppQuickviewByAsset(['advanced_time_series'], {
          advanced_time_series: {
            ...filters,
            cohort: advancedData.cohort,
          },
        })
      );
    }
  }, [advancedData.cohort]);

  return (
    <InsightsCardBox
      bodyMinHeight={106}
      className="advanced-data-performance-qv card-box-sm"
      headerLeft={
        <h4 className="h4">
          {advancedData.title}
          {advancedData.subtitle && ` — ${advancedData.subtitle}`}
        </h4>
      }
    >
      {activeMetrics.map((key) => (
        <div key={key} className="advanced-data-performance-qv__item">
          <div className="advanced-data-performance-qv__item-head">
            {key === keyMetric && <AdvancedKeyMetricTooltip metric={ADVANCED_METRICS_APP[key]} />}
            {ADVANCED_METRICS_APP[key]}
          </div>
          <div className="advanced-data-performance-qv__item-body">
            <YearCohortsChart
              loading={settings.pending}
              series={cohorts}
              metric={key}
              cohort={advancedData.cohort}
              granularity="weekly"
              overPeriod="year_over_year"
              height={246}
              skeletonHeight={280}
              hasTable={false}
              yGridLine
              variant="qv"
              toggleSize=""
              hideSinglePoinLegend
              showTable={false}
              maxDate={filters.to_date}
              subDates={year_sub_dates}
            />
          </div>
        </div>
      ))}
    </InsightsCardBox>
  );
};

AdvancedDataPerformance.propTypes = {
  widgets: T.object.isRequired,
  data: T.object.isRequired,
  settings: T.object.isRequired,
};

export default AdvancedDataPerformance;
